import global from '../../components/global' //引用全局常量文件
import api from '../../utils/api'
export default {
    //滑动限制
    stop: function() {
        document.body.style.overflow = 'hidden';
    },
    //取消滑动限制
    move: function() {
        document.body.style.overflow = ''; //出现滚动条
    },
    //实现汉字转Unicode码
    toUnicode: function(s) {
        return s.replace(/([\u4E00-\u9FA5]|[\uFE30-\uFFA0])/g, function(newStr) {
            return "\\u" + newStr.charCodeAt(0).toString(16);
        });
    },
    getTimeCurrentTime: function(formatDate) {
        let date = new Date();
        let mouth = date.getMonth() + 1;
        let getDay = date.getDate();
        if (mouth < 10) {
            mouth = '0' + mouth;
        }
        if (getDay < 10) {
            getDay = '0' + getDay;
        }
        let currentTime = '';
        if (formatDate) {
            //						currentTime = `${date.getFullYear()}年${mouth}月${getDay}日`;
            currentTime = date.getFullYear() + '年' + mouth + '月' + getDay + '日';
        } else {
            //						currentTime = `${date.getFullYear()}-${mouth}-${getDay}`;
            currentTime = date.getFullYear() + '-' + mouth + '-' + getDay;
        }
        return currentTime;
    },
    // 删除数组中指定的元素
    removeByValue: function(arr, val) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == val) {
                arr.splice(i, 1);
                break;
            }
        }
    },
    //判断微信浏览器
    is_weixn() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        } else {
            return false;
        }
    },
    //清空对象参数值
    clearVal: function(obj) {
        for (let key in obj) {
            obj[key] = ''
        }
    },
    //根据身份证获取出生日期
    getBirthdayFromIdCard: function(idCard) {
        var birthday = "";
        if (idCard != null && idCard != "") {
            if (idCard.length == 15) {
                birthday = "19" + idCard.substr(6, 6);
            } else if (idCard.length == 18) {
                birthday = idCard.substr(6, 8);
            }

            birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
        }
        return birthday;
    },
    //根据身份证号获取出生日期、性别、年龄
    getBirthdatByIdNo: function(UUserCard, num) {
        if (num == 1) {
            //获取出生日期
            var birth = UUserCard.substring(6, 10) + "-" + UUserCard.substring(10, 12) + "-" + UUserCard.substring(12, 14);
            return birth;
        }
        if (num == 2) {
            //获取性别
            if (parseInt(UUserCard.substr(16, 1)) % 2 == 1) {
                //男
                return "男";
            } else {
                //女
                return "女";
            }
        }
        if (num == 3) {
            //获取年龄
            var myDate = new Date();
            var month = myDate.getMonth() + 1;
            var day = myDate.getDate();
            var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
            if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(12, 14) <= day) {
                age++;
            }
            return age;
        }
    },
    /**
     * 键值对处理
     * @param {Object} listObj 需要处理的数组
     */
    dealObj: function(listObj) {
        let newObj = {};
        for (let j of listObj) {
            newObj[j['code']] = j.name;
        }
        return newObj;
    },
    dealObjLabel: function(listObj) {
        let newObj = {};
        for (let j of listObj) {
            newObj[j['value']] = j.label;
        }
        return newObj;
    },

    //截取字符串 拼成**
    plusXing: function(str, frontLen, endLen) {
        var len = str.length - frontLen - endLen;
        var xing = '';

        for (var i = 0; i < len; i++) {
            xing += '*';
        }
        return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
    },
    // 获取URL中参数值 - 正则法
    getQueryString: function(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var locHash = window.location.hash;
        var r = locHash.substr(locHash.indexOf("?") + 1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    },
    //获取url参数openId
    GetQueryString: function(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },

    //获取url参数 中文参数
    GetQueryStringChinese: function(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURIComponent(r[2]);
        return null;
    },

    getOpenId: function() {
        let _sessionStorageId = sessionStorage.getItem("openId");
        let _linkOpenId = this.GetQueryString("openId");
        if (_sessionStorageId != null || _linkOpenId != null) {
            if (_linkOpenId != null) {
                sessionStorage.setItem("openId", _linkOpenId);
            };
            if (_sessionStorageId != null) {
                sessionStorage.setItem("openId", _sessionStorageId);
            };
        } else {
            var url = encodeURIComponent(window.location.href);
            //			alert('url:'+url)
            window.location.href = global.domainName + "index/base?from=" + url;
            //			location.href = "http://healthWebt.mobimedical.cn/index/base?from=" + url;
        }
    },
    setCookie: function(c_name, value, expiredays) {
        var exdate = new Date()
        exdate.setDate(exdate.getDate() + expiredays)
        document.cookie = c_name + "=" + escape(value) +
            ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString())
    },
    getCookie: function(c_name) {
        if (document.cookie.length > 0) {
            var c_start = document.cookie.indexOf(c_name + "=")
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1
                var c_end = document.cookie.indexOf(";", c_start)
                if (c_end == -1) c_end = document.cookie.length
                return unescape(document.cookie.substring(c_start, c_end))
            }
        }
        return ""
    },
    removeCookie: function(c_name) {
        //TODO
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getCookie(c_name);
        if (cval != null)
            document.cookie = c_name + "=" + cval + ";expires=" + exp.toGMTString();
    },
    //判断元素是否已存在
    isInArray: function(arr, value) {
        for (var i = 0; i < arr.length; i++) {
            if (value === arr[i]) {
                return true;
            }
        }
        return false;
    },
    //正则匹配搜索
    //开始搜索 正则匹配
    searchNotes: function(data, value) {
        var aData = [],
            aSearch = value.split(' '),
            k = 0,
            regStr = '',
            reg;
        for (var r = 0, lenR = aSearch.length; r < lenR; r++) {
            regStr += '(' + aSearch[r] + ')([\\s\\S]*)';
        }
        reg = new RegExp(regStr);
        for (var i = 0, lenI = data.length; i < lenI; i++) {
            var name = data[i].name,
                regMatch = name.match(reg),
                searchData = {};
            k = 0;
            if (regMatch !== null) {
                var replaceReturn = "";
                for (var j = 1, lenJ = regMatch.length; j < lenJ; j++) {
                    if (regMatch[j] === aSearch[k]) {
                        replaceReturn += '$' + j + '';
                        k++;
                    } else {
                        replaceReturn += '$' + j;
                    }
                }
                for (var obj in data[i]) {
                    if (data[i].hasOwnProperty(obj)) {
                        searchData[obj] = data[i][obj];
                    }
                }
                searchData.name = searchData.name.replace(reg, replaceReturn); //.replace(reg, replaceReturn);
                aData.push(searchData);
            }
        }

        return aData;
    },
    /** 
     * 时间戳格式化函数 
     * @param  {string} format    格式 
     * @param  {int}    timestamp 要格式化的时间 默认为当前时间 
     * @return {string}           格式化的时间字符串 
     */

    date: function(format, timestamp) {
        var a, jsdate = ((timestamp) ? new Date(timestamp * 1000) : new Date());
        var pad = function(n, c) {
            if ((n = n + "").length < c) {
                return new Array(++c - n.length).join("0") + n;
            } else {
                return n;
            }
        };
        var txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        var txt_ordin = {
            1: "st",
            2: "nd",
            3: "rd",
            21: "st",
            22: "nd",
            23: "rd",
            31: "st"
        };
        var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var f = {
            // Day 
            d: function() {
                return pad(f.j(), 2)
            },
            D: function() {
                return f.l().substr(0, 3)
            },
            j: function() {
                return jsdate.getDate()
            },
            l: function() {
                return txt_weekdays[f.w()]
            },
            N: function() {
                return f.w() + 1
            },
            S: function() {
                return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'
            },
            w: function() {
                return jsdate.getDay()
            },
            z: function() {
                return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0
            },

            // Week 
            W: function() {
                var a = f.z(),
                    b = 364 + f.L() - a;
                var nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
                if (b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b) {
                    return 1;
                } else {
                    if (a <= 2 && nd >= 4 && a >= (6 - nd)) {
                        nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
                        return date("W", Math.round(nd2.getTime() / 1000));
                    } else {
                        return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0);
                    }
                }
            },

            // Month 
            F: function() {
                return txt_months[f.n()]
            },
            m: function() {
                return pad(f.n(), 2)
            },
            M: function() {
                return f.F().substr(0, 3)
            },
            n: function() {
                return jsdate.getMonth() + 1
            },
            t: function() {
                var n;
                if ((n = jsdate.getMonth() + 1) == 2) {
                    return 28 + f.L();
                } else {
                    if (n & 1 && n < 8 || !(n & 1) && n > 7) {
                        return 31;
                    } else {
                        return 30;
                    }
                }
            },

            // Year 
            L: function() {
                var y = f.Y();
                return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0
            },
            //o not supported yet 
            Y: function() {
                return jsdate.getFullYear()
            },
            y: function() {
                return (jsdate.getFullYear() + "").slice(2)
            },

            // Time 
            a: function() {
                return jsdate.getHours() > 11 ? "pm" : "am"
            },
            A: function() {
                return f.a().toUpperCase()
            },
            B: function() {
                // peter paul koch: 
                var off = (jsdate.getTimezoneOffset() + 60) * 60;
                var theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off;
                var beat = Math.floor(theSeconds / 86.4);
                if (beat > 1000) beat -= 1000;
                if (beat < 0) beat += 1000;
                if ((String(beat)).length == 1) beat = "00" + beat;
                if ((String(beat)).length == 2) beat = "0" + beat;
                return beat;
            },
            g: function() {
                return jsdate.getHours() % 12 || 12
            },
            G: function() {
                return jsdate.getHours()
            },
            h: function() {
                return pad(f.g(), 2)
            },
            H: function() {
                return pad(jsdate.getHours(), 2)
            },
            i: function() {
                return pad(jsdate.getMinutes(), 2)
            },
            s: function() {
                return pad(jsdate.getSeconds(), 2)
            },
            //u not supported yet 

            // Timezone 
            //e not supported yet 
            //I not supported yet 
            O: function() {
                var t = pad(Math.abs(jsdate.getTimezoneOffset() / 60 * 100), 4);
                if (jsdate.getTimezoneOffset() > 0) t = "-" + t;
                else t = "+" + t;
                return t;
            },
            P: function() {
                var O = f.O();
                return (O.substr(0, 3) + ":" + O.substr(3, 2))
            },
            //T not supported yet 
            //Z not supported yet 

            // Full Date/Time 
            c: function() {
                return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P()
            },
            //r not supported yet 
            U: function() {
                return Math.round(jsdate.getTime() / 1000)
            }
        };
        //       /[\\]?([a-zA-Z])/g
        return format.replace(/[\\]?([a-zA-Z])/g, function(t, s) {
            if (t != s) {
                // escaped 
                var ret = s;
            } else if (f[s]) {
                // a date function exists 
                ret = f[s]();
            } else {
                // nothing special 
                ret = s;
            }
            return ret;
        });
    },
    //date('Y-m-d','1350052653');//很方便的将时间戳转换成了2012-10-11 
    //date('Y-m-d H:i:s','1350052653');//得到的结果是2012-10-12 22:37:33
    //cookie 搜索记录
    localLogMod: function(keyword, localKey) {
        // 过滤一个结果的空记录添加，过滤空搜索  
        keyword = keyword.trim();
        if (keyword) {
            let arrLen = 6; //历史记录长度
            let historyKeywordCookieName = "__C_HISTORY_KEYWORD"; //cookie名
            localKey = this.getCookie(historyKeywordCookieName); //获取历史搜索记录
            //console.log("historyKeyword:" + localKey);
            if (localKey != "") {
                let historyKeywordArr = localKey.split("|");
                //console.log("historyKeywordArr长度:" + historyKeywordArr.length)
                if (!this.isInArray(historyKeywordArr, keyword)) { //判断是否存在该记录
                    if (historyKeywordArr.length != arrLen) {
                        let Temp = "";
                        historyKeywordArr.unshift(keyword);
                        for (var i = 0; i < historyKeywordArr.length; i++) {
                            Temp += historyKeywordArr[i] + "|";
                        }
                        Temp = Temp.substring(0, Temp.length - 1);
                        this.setCookie(historyKeywordCookieName, Temp);
                    } else {
                        historyKeywordArr.splice(historyKeywordArr.length - 1);

                        let Temp = "";
                        historyKeywordArr.unshift(keyword);
                        for (var i = 0; i < historyKeywordArr.length; i++) {
                            Temp += historyKeywordArr[i] + "|";
                        }
                        Temp = Temp.substring(0, Temp.length - 1);
                        this.setCookie(historyKeywordCookieName, Temp);
                    }
                }
            } else {
                this.setCookie(historyKeywordCookieName, keyword);
            }
        }
    },
    getBase64: function(imgUrl, cb, type = 'base64') {
        window.URL = window.URL || window.webkitURL;
        let xhr = new XMLHttpRequest();
        xhr.open("get", imgUrl, true);
        // 至关重要
        xhr.responseType = "blob";
        xhr.onload = function() {
            if (this.status == 200) {
                //得到一个blob对象
                let blob = this.response;
                //  至关重要
                let oFileReader = new FileReader();
                oFileReader.onloadend = function(e) {
                    let base64 = e.target.result;

                    if (type === 'base64') cb(base64)
                        //作为背景
                };
                oFileReader.readAsDataURL(blob);
                let src = window.URL.createObjectURL(blob);
                if (type === 'blob') cb(src)
            }
        }
        xhr.send();
    },
    getDataByKey: function(key) {
        var msg = null;
        if (
            typeof localStorage[key] == 'undefined' ||
            localStorage[key] === null ||
            localStorage[key] == 'null'
        ) {
            return null;
        } else {
            msg = JSON.parse(localStorage[key]);
            if (!msg.info || msg.info === null || msg.info.length === 0) return null;
        }

        return msg.info;
    },
    saveDataByKey: function(key, data = "") {

        var msg = {
            info: data,
        };
        localStorage[key] = JSON.stringify(msg);
    },
    getUrlParam: function(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },
    deepCopy: function(obj) {
        var result = Array.isArray(obj) ? [] : {};
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    result[key] = this.deepCopy(obj[key]); //递归复制
                } else {
                    result[key] = obj[key];
                }
            }
        }
        return result;
    },
    removeLsItem: function(key) {
        window.localStorage.removeItem(key)
    },
    getDateTime(timestamp) {
        if (timestamp) {
            timestamp = timestamp * 1000;
            let d = new Date(timestamp);
            return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        } else {
            let d = new Date();
            return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        }
    },
    is_WeixinOrAlipay: function() {
        var ua = window.navigator.userAgent.toLowerCase();
        //判断是不是微信
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return "weixin";
        }
        //判断是不是支付宝
        if (ua.match(/AlipayClient/i) == "alipayclient") {
            return "alipay";
        }
        //哪个都不是
        return "not";
    },
    moduleStatistics: function(param) {
        let query = param || {};
        api.post('/index/saveNode', query, (res) => {
            console.log(res)
        });
    }

}


// WEBPACK FOOTER //
// ./src/assets/js/common.js